import { SkeletonBodyText, Text } from "@shopify/polaris"

const CheckoutPagePreview = () => {
  return (
    <div className="bg-[#f7f7f7] rounded-lg border border-[#e3e3e3] overflow-hidden">
      <div className="px-4 pt-4">
        <Text as="p" variant="bodyMd" tone="subdued" fontWeight="semibold">
          {t("CustomerBoughtFreeReturnService")}{" "}
        </Text>
        <div className="mt-2">
          <Text as="p" variant="bodyMd" tone="subdued">
            {t("RefundToStoreCredit")}{" "}
          </Text>
        </div>
        <div className="mt-3 space-y-2">
          <div className="w-[160px]">
            <SkeletonBodyText lines={1} />
          </div>
          <div className="w-[250px]">
            <SkeletonBodyText lines={1} />
          </div>
        </div>
        <div className="mt-2 flex items-center justify-between">
          <Text as="span" variant="bodyMd" tone="subdued">
            {t("Subtotal")}{" "}
          </Text>
          <div className="w-[108px] mr-5">
            <SkeletonBodyText lines={1} />
          </div>
        </div>
        <div className="mt-1 mb-10 flex items-center justify-between">
          <Text as="span" variant="bodyMd" tone="subdued">
            {t("ShippingFee")}{" "}
          </Text>
          <div className="inline-flex h-5 items-center rounded-[8px] bg-[#e0f0ff] pr-2 text-[#00527c] mr-5">
            <span className="flex size-5 items-center justify-center">
              <svg
                className="w-[14px] h-[14px]"
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                width="100%"
                height="100%"
                overflow="visible"
                viewBox="0 0 13.8535 14.003"
                fill="none"
              >
                <g id="Icon">
                  <path
                    d="M1.63187 5.81108C2.28932 2.84551 5.22635 0.974419 8.19191 1.63187C8.59631 1.72152 8.99681 1.46637 9.08647 1.06198C9.17612 0.657581 8.92097 0.257076 8.51657 0.167424C4.74222 -0.66933 1.00418 1.71207 0.167424 5.48642C-0.66933 9.26077 1.71206 12.9988 5.48642 13.8356C9.26077 14.6723 12.9988 12.2909 13.8356 8.51657C13.9252 8.11218 13.6701 7.71167 13.2657 7.62202C12.8613 7.53237 12.4608 7.78752 12.3711 8.19191C11.7137 11.1575 8.77664 13.0286 5.81108 12.3711C2.84551 11.7137 0.974418 8.77664 1.63187 5.81108Z"
                    fill="#0094D5"
                  />
                  <path
                    d="M13.0318 3.78131C13.3247 3.48842 13.3247 3.01354 13.0318 2.72065C12.7389 2.42776 12.2641 2.42776 11.9712 2.72065L7.0015 7.69032L4.78183 5.47065C4.48894 5.17776 4.01406 5.17776 3.72117 5.47065C3.42828 5.76354 3.42828 6.23842 3.72117 6.53131L6.47117 9.28131C6.76406 9.5742 7.23894 9.5742 7.53183 9.28131L13.0318 3.78131Z"
                    fill="#0094D5"
                  />
                </g>
                <script />
              </svg>
            </span>
            <Text as="span" variant="bodySm" tone="base" fontWeight="medium">
              {t("FreeShipping")}{" "}
            </Text>
          </div>
        </div>
      </div>
      <div className="border-t border-[#e3e3e3] bg-[#e3e3e3] px-2 py-1 text-center">
        <Text as="span" variant="bodySm" tone="subdued" fontWeight="medium">
          {t("SubmitReturnRequest")}{" "}
        </Text>
      </div>
    </div>
  )
}
export default CheckoutPagePreview
